import * as React from 'react';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { ButtonComponent } from '../../../toolkit/button/buttoncomponent';
import { UIComponentState, UIDataModel } from '../../../toolkit/uicomponent';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { ConfirmRequestCancelButtonCSSStyleImpl } from '../confirmrequest/confirmrequestcancelbutoncss';
import './flash-style.css';
import { FlashComponentHandler, FlashComponentProps } from './flashcomponent';
import { FlashCSSStyle } from './flashcss';



export class FlashViewImpl extends UIComponentViewImpl<UIDataModel>
{
    bindHandlers()
    {   
        this.onSubscibeNow = this.onSubscibeNow.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
    }

    draw(props: FlashComponentProps, state: UIComponentState, cssStyle: FlashCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
             
            <div id="flash-wrapper" >
            {
                this.getWebView(props, state, cssStyle)
            }
            </div>
            <div id="flash-tab-wrapper">
                        {
                            this.getTabView(props, state, cssStyle)
                        }
            </div>
            <div id="flash-col-wrapper">
                        {
                            this.getMobileView(props, state, cssStyle)
                        }
            </div>
            </div>
        );
    }

    getWebView(props: FlashComponentProps, state: UIComponentState, cssStyle:FlashCSSStyle)
    {
        return(
            <>
                <div style={cssStyle.getInnerWrapperDivCSSStyle()}>
                    <img width="100%" height="100%" src={this.getContext().getResources().getImage("flash.svg")}/>
                    <div style={{position:"absolute",top:"0px",width:"100%"}}>  
                        <div style={{width:"100%",cursor:"pointer",height:"60px",textAlign:"right",marginBottom:"95px",marginTop:"22px",paddingRight:"22px"}}>
                            <img onClick={this.onCloseClick} width="60px" height="60px" src={this.getContext().getResources().getImage("flash_close.svg")}/>

                        </div>
                        <div id="flash-inner-content" style={{}}>  

                            <div style={{width:"100%", height:"30px",lineHeight:"30px",fontSize:"30px",fontWeight:900,color:"#000000",textAlign:"center", fontFamily:this.getContext().getResources().getFontFamily()}}>
                                    {this.getContext().getResources().getString(Strings.buffet_pack)}
                            </div>
                            <label style={cssStyle.getPackDetailsContentDiv()}>
                                        {this.getContext().getResources().getString(Strings.pack_of_10_tunes)}
                            </label>
                            <label style={{width:"100%",textAlign:"center",height:"20px",lineHeight:"30px",fontSize:"14px",color:"#FFFFFF",marginTop:"40px",fontFamily:this.getContext().getResources().getFontFamily()}}>
                                        {this.getContext().getResources().getString(Strings.charges)}
                            </label>
                            <label style={{width:"100%",textAlign:"center",height:"19px",lineHeight:"19px",fontSize:"14px",color:"#FFCD00",marginTop:"0px",fontWeight:600, fontFamily:this.getContext().getResources().getFontFamily()}}>
                                        {this.getContext().getConfigurationSettings().getProperty("CRBT_EAUC_CHARGES")}
                                        {/* {"500k/month"} */}
                            </label>
                    
                                <div style={{width:'209px',height:'40px',marginLeft:"auto",marginRight:"auto"}}>
                                    <ButtonComponent onClick={this.onSubscibeNow} style={new ConfirmRequestCancelButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.subscribe)}/>
                                </div>

                        </div>        
                    </div>    
            </div>          
            </>
        );
    }

    getTabView(props: FlashComponentProps, state: UIComponentState, cssStyle:FlashCSSStyle)
    {
        return(
            <>
                <div style={cssStyle.getInnerWrapperDivCSSStyle()}>
                    <img width="100%" height="100%" src={this.getContext().getResources().getImage("flash.svg")}/>
                    <div style={{position:"absolute",top:"0px",width:"100%"}}>  
                        <div id="flash-close-div" style={{cursor:"pointer"}}>
                            <img onClick={this.onCloseClick} width="60px" height="60px" src={this.getContext().getResources().getImage("flash_close.svg")}/>

                        </div>
                        <div id="flash-inner-content" style={{}}>  

                            <div style={{width:"100%",height:"30px",lineHeight:"30px",fontSize:"30px",fontWeight:900,color:"#000000",textAlign:"center", fontFamily:this.getContext().getResources().getFontFamily()}}>
                                    {this.getContext().getResources().getString(Strings.buffet_pack)}
                            </div>
                            <label style={cssStyle.getTabPackDetailsContentDiv()}>
                                        {this.getContext().getResources().getString(Strings.pack_of_10_tunes)}
                            </label>
                            <label style={{width:"100%",textAlign:"center",height:"20px",lineHeight:"30px",fontSize:"14px",color:"#FFFFFF",marginTop:"40px",fontFamily:this.getContext().getResources().getFontFamily()}}>
                                        {this.getContext().getResources().getString(Strings.charges)}
                            </label>
                            <label style={{width:"100%",textAlign:"center",height:"19px",lineHeight:"19px",fontSize:"14px",color:"#FFCD00",marginTop:"0px",fontWeight:600, fontFamily:this.getContext().getResources().getFontFamily()}}>
                                        {this.getContext().getConfigurationSettings().getProperty("CRBT_EAUC_CHARGES")}
                                        {/* {"500k/month"} */}
                            </label>
                    
                                <div style={{width:'209px',height:'40px',marginLeft:"auto",marginRight:"auto"}}>
                                    <ButtonComponent onClick={this.onSubscibeNow} style={new ConfirmRequestCancelButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.subscribe)}/>
                                </div>
                        </div>        
                    </div>    
            </div>          
            </>
        );
    }


        getMobileView(props: FlashComponentProps, state: UIComponentState, cssStyle: FlashCSSStyle){
            return(
                    <div style={cssStyle.getInnerWrapperDivCSSStyle()}>
                        <img width="100%" height="100%" src={this.getContext().getResources().getImage("flash_mobile.svg")}/>
                        <div style={{position:"absolute",top:"0px",width:"100%"}}>  
                            <div id="flash-close-div" style={{cursor:"pointer"}}>

                            <img onClick={this.onCloseClick} width="32px" height="32px" src={this.getContext().getResources().getImage("flash_close.svg")}/>
                            </div>
                             
                            <div id="flash-inner-content">  
 
                                <div style={{width:"100%",marginLeft:"10px", height:"30px",lineHeight:"30px",fontSize:"24px",fontWeight:900,color:"#000000",textAlign:"center", fontFamily:this.getContext().getResources().getFontFamily()}}>
                                    {this.getContext().getResources().getString(Strings.buffet_pack)}
                                </div>
                                <label style={cssStyle.getMobilePackDetailsContentDiv()}>
                                        {this.getContext().getResources().getString(Strings.pack_of_10_tunes)}
                                </label>
                                <label style={{width:"100%",textAlign:"center",height:"20px",lineHeight:"30px",fontSize:"14px",color:"#FFFFFF",marginTop:"40px",fontFamily:this.getContext().getResources().getFontFamily()}}>
                                        {this.getContext().getResources().getString(Strings.charges)}
                                </label>
                                <label style={{width:"100%",textAlign:"center",height:"19px",lineHeight:"19px",fontSize:"14px",color:"#FFCD00",marginTop:"0px",fontWeight:600, fontFamily:this.getContext().getResources().getFontFamily()}}>
                                    {this.getContext().getConfigurationSettings().getProperty("CRBT_EAUC_CHARGES")}
                                    {/* {"500k/month"} */}
                                </label>

                                <div style={{width:'209px',height:'40px',marginLeft:"auto",marginRight:"auto"}}>
                                    <ButtonComponent onClick={this.onSubscibeNow} style={new ConfirmRequestCancelButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.subscribe)}/>
                                </div>
                            </div>    
                        </div>

                    </div>    

            );
        }

    // getMobileView(props: FlashComponentProps, state: UIComponentState, cssStyle: FlashCSSStyle)
    // {
    //     return(
    //         <>  
    //         <div style={cssStyle.getInnerWrapperDivCSSStyle()}>
    //         <img style={{width:'100%',height:"100%"}} src={this.getContext().getResources().getImage("flash_mobile.svg")}/>
    //         <div  style={{width:"100%",height:"32px",cursor:"pointer",top:"0px",position:"absolute", textAlign:"right",paddingTop:"15px",paddingRight:"15px"}}>
    //             <img onClick={this.onCloseClick}  width="32px" height="32px" src={this.getContext().getResources().getImage("flash_close.svg")}/>

    //         </div>
    //         <div id="flash-inner-content" style={{}}>  

           
    //         <div style={{width:"100%",marginLeft:"10px", height:"30px",lineHeight:"30px",fontSize:"24px",fontWeight:900,color:"#000000",textAlign:"center", fontFamily:this.getContext().getResources().getFontFamily()}}>
    //             {this.getContext().getResources().getString(Strings.buffet_pack)}
    //         </div>
    //         <label style={cssStyle.getMobilePackDetailsContentDiv()}>
    //                 {this.getContext().getResources().getString(Strings.pack_of_10_tunes)}
    //         </label>
    //         <label style={{width:"100%",textAlign:"center",height:"20px",lineHeight:"30px",fontSize:"14px",color:"#FFFFFF",marginTop:"40px",fontFamily:this.getContext().getResources().getFontFamily()}}>
    //                 {this.getContext().getResources().getString(Strings.charges)}
    //         </label>
    //         <label style={{width:"100%",textAlign:"center",height:"19px",lineHeight:"19px",fontSize:"14px",color:"#FFCD00",marginTop:"0px",fontWeight:600, fontFamily:this.getContext().getResources().getFontFamily()}}>
    //                 {this.getContext().getConfigurationSettings().getProperty("CRBT_EAUC_CHARGES")}
    //                 {/* {"500k/month"} */}
    //         </label>

    //         <div style={{width:'209px',height:'40px',marginLeft:"auto",marginRight:"auto"}}>
    //             <ButtonComponent onClick={this.onSubscibeNow} style={new ConfirmRequestCancelButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.subscribe)}/>
    //         </div>
    //         </div>
    //         </div>
           
        
                      
    //         </>
    //     );
    // }
   
    
    private onCloseClick()
    {
        console.log("On close popup");
        (this.getUIComponentHandler() as FlashComponentHandler).closePopup();
    }
  
    
    private onSubscibeNow():void
    {
        (this.getUIComponentHandler() as FlashComponentHandler).onSubscibeNow();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/flashpopup/flashview.tsx